import { render, staticRenderFns } from "./VirtualSteper.vue?vue&type=template&id=47095a58&"
import script from "./VirtualSteper.vue?vue&type=script&lang=js&"
export * from "./VirtualSteper.vue?vue&type=script&lang=js&"
import style0 from "./VirtualSteper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports